import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const PencilIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      d="M2.237 10l2.829 2.828-3.398 1.184c-.52.18-.791-.105-.614-.614L2.237 10zM14 12c.552 0 1 .448 1 1s-.448 1-1 1H9c-.552 0-1-.448-1-1s.448-1 1-1h5zm-1.49-9.586c.781.781.781 2.048 0 2.829l-6.473 6.473L3.21 8.887l6.473-6.473c.781-.78 2.047-.78 2.828 0z"
      fill={color}
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default PencilIcon;
